import React from 'react';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-content">
          <p className="about-text">
            Masigo brings authentic Korean cuisine to the heart of London's Chapel Market. 
            Known for its generous portions, traditional flavours and warm atmosphere, 
            the restaurant has become a favourite for both casual lunches and hearty dinners.
          </p>
          <p className="about-text">
            With a 4.6-star rating and over 680 reviews, Masigo delivers a true Korean 
            dining experience — from crispy Yangnyeom chicken to comforting kimchi jjigae.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
